import { signal, WritableSignal } from "@angular/core";
import { DocumentDto } from "@app/catalog";

export class DocumentModel {
  public id: string = "";

  public name: WritableSignal<string>;
  public thumbnailUrl: WritableSignal<string | null>;
  public version: WritableSignal<number>;
  public uploadedById: WritableSignal<string>;
  public uploadedByName: WritableSignal<string>;
  public uploadedByFullName: WritableSignal<string>;
  public uploadedDate: WritableSignal<string>;
  public superseded: WritableSignal<boolean>;
  public starred: WritableSignal<boolean>;
  public hasImageError: WritableSignal<boolean> = signal(false);

  constructor() {
    this.name = signal("");
    this.thumbnailUrl = signal<string | null>(null);
    this.version = signal(0);
    this.uploadedById = signal("");
    this.uploadedByName = signal("");
    this.uploadedByFullName = signal("");
    this.uploadedDate = signal("");
    this.superseded = signal(false);
    this.starred = signal(false);
  }

  public static fromDto(dto: DocumentDto): DocumentModel {
    const document = new DocumentModel();

    document.id = dto.id;
    document.name.set(dto.name);
    document.thumbnailUrl.set(dto.thumbnailUrl);
    document.version.set(dto.version);
    document.uploadedById.set(dto.uploadedBy?.id ?? "");
    document.uploadedByName.set(dto.uploadedBy?.userName ?? "");
    document.uploadedByFullName.set(dto.uploadedBy?.fullName ?? "");
    document.uploadedDate.set(dto.uploadedDate);
    document.superseded.set(dto.superseded);
    document.starred.set(dto.starred);

    return document;
  }

  public handleImageError(): void {
    this.hasImageError.set(true);
  }
}